var LoadTemplates = function () {
  $.ajax({
    url: `/Templates.html?v=${appVersion}`,
    dataType: 'html',
    async: false,
    cache: true,
    success: function (data) {
      $('body').append(data);
    }
  });
}

export default LoadTemplates;